module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M.031 14.142L14.173 0l1.414 1.414L1.445 15.556z\"/><path d=\"M1.415.031l14.142 14.142-1.415 1.414L0 1.445z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/close.svg
// module id = 33
// module chunks = 0